







import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  name: "AppDateDisplay"
})
export default class extends Vue {
  @Prop({ required: true }) date!: string | Date;
  @Prop({ default: "medium" }) size!: "small" | "medium" | "large";
  @Prop({ default: "YYYY. MM. DD." }) format!: string;
}
